export default {
  setMigrationDialogHeader: 'Nastaviť začiatok migrácie',
  setMessage: 'Stav migrácie {count} {type} sa resetuje a všetky {type} sa znova migrujú od {date}.',
  setMigrationDialogErrorPast: 'Dátum musí byť v minulosti',
};
